import React from 'react';

import { useBlurOverlayStylesWhenAppIsInactive } from '@ocx-app/components/blur/blur-overlay-when-app-is-inactive.component';
import { PaymentAccountType } from '@ocx/graphql';

import { AddCardLayout } from './add-card-sdk-based-layout';
import { AddCreditCard } from './add-credit-card.component';
import { useAddCardController } from './add-card-sdk-based-controller.hook';
import { AddPrepaidCard } from './add-prepaid-card.component';

export type AddCardControllerProps = {
  type: Extract<PaymentAccountType, 'CREDIT' | 'PREPAID'>;
  onCardAdded?(params: { paymentInstrumentId: string | null }): void;
};

export const AddCardController = (props: AddCardControllerProps) => {
  const { type, onCardAdded } = props;
  const { loading, cardholderName, handleSubmit } = useAddCardController({ onCardAdded });
  const blurOverlayStyles = useBlurOverlayStylesWhenAppIsInactive();

  return (
    <AddCardLayout loading={loading} wrapperSx={blurOverlayStyles}>
      {type === PaymentAccountType.Prepaid ? (
        <AddPrepaidCard onSubmit={handleSubmit} />
      ) : (
        <AddCreditCard cardholderName={cardholderName} onSubmit={handleSubmit} />
      )}
    </AddCardLayout>
  );
};
